




































































































































































































































import Vue, { PropType } from "vue";
import HttpClientFactory from "../../../../services/HttpClientFactory";
import HttpClient from "../../../../services/HttpClient";
import Invoice from "../../../../types/invoices/Invoice";
import ApiReceiver from "../../../../types/receivers/api/ApiReceiver";
import ReceiverIndexResponse from "../../../../types/receivers/api/ReceiverIndexResponse";
import { TimeSelect, DatePicker, Select, Option } from "element-ui";
import { snakeCase } from "lodash";
import BaseInput from "../../../../types/black_dashboard_template/BaseInput";
import swal from "sweetalert2";
import ApiInvoiceRequest from "../../../../types/invoices/api/ApiInvoiceRequest";
import InvoiceLine from "../../../../types/invoices/InvoiceLine";
import moment from "moment";

interface ReceiverSelectorOption {
  value: number;
  label: string;
}

interface IsUniqueNumberApiResponse {
  isUnique: boolean;
}

export default Vue.extend({
  name: "edit-invoices-data-form",
  props: {
    invoiceId: {
      required: true,
    },
    invoice: {
      required: true,
      type: Object as PropType<Invoice>,
    },
  },
  components: {
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data() {
    return {
      httpClient: {} as HttpClient,
      receiverSelector: {
        selectedOption: null,
        options: [] as ReceiverSelectorOption[],
      },
    };
  },
  computed: {
    getInvoiceData(): Invoice {
      return this.invoice;
    },
  },
  created() {
    this.httpClient = HttpClientFactory.getInstance();
    this.getReceivers();
  },
  methods: {
    findReceiver() {
      return this.receiverSelector.options.find(
        (option: ReceiverSelectorOption) =>
          option.value === this.invoice.receiver.id
      );
    },
    receiverLabel({ value, label }: ReceiverSelectorOption): string {
      return label;
    },
    setReceiverId(option: ReceiverSelectorOption) {
      this.invoice.receiver.id = option.value;
    },
    getReceivers() {
      this.httpClient
        .get(process.env.VUE_APP_BACKEND_ENDPOINT + "/receivers/v1/view")
        .then((res: any) => {
          const apiReceiver: ReceiverIndexResponse = res.data;

          this.receiverSelector.options = apiReceiver
            .filter(
              (receiver) =>
                !receiver.deletedAt || this.invoice.receiver.id === receiver.id
            )
            .map((receiverData: ApiReceiver) => {
              return {
                value: receiverData.id,
                label: receiverData.companyName,
              };
            });
        })
        .catch((e: any) => {
          const error: any = {
            text: this.$t("invoices:error"),
            type: "error",
          };
          this.$notify(error);
        });
    },
    async validateAndUpdateInvoice() {
      const refInvoiceNumber = this.$refs.invoiceNumber as BaseInput;
      if (refInvoiceNumber.touched) {
        if (!(await this.isUniqueInvoiceNumber())) {
          try {
            const result = await swal.fire({
              title: this.$t(
                "invoices:create.repeated_number.question_invoice_number"
              ),
              text: this.$t(
                "invoices:create.repeated_number.text_repeat_invoice_number"
              ),
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: this.$t(
                "invoices:create.repeated_number.buttons.yes"
              ),
              cancelButtonText: this.$t(
                "invoices:create.repeated_number.buttons.no"
              ),
              customClass: {
                confirmButton: "btn btn-next btn-wd btn-primary",
                cancelButton: "btn btn-next btn-wd btn-danger",
              },
              buttonsStyling: false,
            });
            if (result.isDismissed) {
              return;
            }
            if (result.isConfirmed) {
              await this.updateInvoice();
              return;
            }
          } catch (e) {
            const error: any = {
              text: this.$t("invoices:error"),
              type: "error",
            };
            this.$notify(error);
          }
        }
      }
      await this.updateInvoice();
    },
    async isUniqueInvoiceNumber(): Promise<boolean> {
      try {
        const res: any = await this.httpClient.post(
          process.env.VUE_APP_BACKEND_ENDPOINT +
            "/invoice/v1/is-unique-invoice-number",
          this.invoice
        );
        const responseData: IsUniqueNumberApiResponse = res.data;
        return responseData.isUnique;
      } catch (e) {
        const error: any = {
          text: this.$t("invoices:error"),
          type: "error",
        };
        this.$notify(error);
        return false;
      }
    },
    async updateInvoice() {
      try {
        const transformedData: ApiInvoiceRequest = {
          receiverId: this.invoice.receiver.id,
          invoiceDateAt: moment(this.invoice.invoiceDateAt).format(
            "YYYY-MM-DD"
          ),
          invoiceNumber: this.invoice.invoiceNumber,
          dueDateAt: moment(this.invoice.dueDateAt).format("YYYY-MM-DD"),
          description: this.invoice.description,
          priceWithoutVatAndTaxes:
            this.invoice.priceWithoutVatAndTaxes.intValue,
          vat: this.invoice.vat.intValue,
          grandTotal: this.invoice.grandTotal.intValue,
          lines: this.invoice.lines.map((line: InvoiceLine) => ({
            description: line.description,
            qty: line.qty,
            unit: line.unit,
            price: line.price.intValue,
            vat: line.vat,
            totalVat: line.totalVat.intValue,
          })),
        };

        await this.httpClient.put(
          process.env.VUE_APP_BACKEND_ENDPOINT +
            `/invoice/v1/${this.invoiceId}`,
          transformedData
        );
        const success: any = {
          text: this.$t("invoices:saved"),
          type: "success",
        };
        this.$notify(success);
        this.$emit("on-update", this.invoice);
      } catch (e) {
        const errorCode: string = e.response.data.code;
        const arrayOfErrors: any[] = e.response.data.errors;

        if (arrayOfErrors !== undefined) {
          arrayOfErrors.forEach((error: any) => {
            this.showValidationError(
              snakeCase(error.field),
              snakeCase(error.rule)
            );
          });
        }
        this.showGenericError(errorCode, "warn");
      }
    },
    showGenericError(code: string, type: string) {
      const error: any = {
        text: this.$t(`invoices:${code}`),
        type,
      };
      this.$notify(error);
    },
    toMonetaryUnit(input: number) {
      return Math.round(input * 100);
    },
    showValidationError(field: string, rule: string) {
      const error: any = {
        text: this.$t("invoices:validate." + field + "." + rule),
        type: "error",
      };
      this.$notify(error);
    },
  },
});
